import React from 'react';
import { BranchFormModalView } from './BranchFormModalView';
import {
    useBranchForm,
    type BranchFormInitialValues,
    type BranchFormSubmit,
} from './useBranchForm';

type BranchFormModalProps = {
    error: string | null;
    initialValues: BranchFormInitialValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: BranchFormSubmit) => void;
};

/**
 * Container for the Add / Edit Branch modal: instantiates the form-state hook
 * and hands its output (plus the modal-chrome props) to the render-only View.
 */
export const BranchFormModal: React.FC<BranchFormModalProps> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
}) => {
    const form = useBranchForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        onSubmit,
    });

    return (
        <BranchFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
